import { Avatar, AvatarFallback } from 'src/components/ui/avatar';
import { TBlockchain } from 'src/types';
import { chainIconMap } from 'src/utils/icons';

interface BlockchainAvatarProps {
  chain: TBlockchain;
}

const getBlockchainIcon = (chain: TBlockchain) => {
  switch (chain) {
    case 'arbitrum':
      return {
        icon: chainIconMap.arbitrum,
        bgColor: 'bg-gray-200',
        textColor: 'text-gray-900',
      };
    case 'base':
      return {
        icon: chainIconMap.base,
        bgColor: 'bg-gray-200',
        textColor: 'text-gray-900',
      };
    case 'bitcoin':
      return {
        icon: chainIconMap.bitcoin,
        bgColor: 'bg-orange-200',
        textColor: 'text-orange-900',
      };
    case 'ethereum':
      return {
        icon: chainIconMap.ethereum,
        bgColor: 'bg-blue-200',
        textColor: 'text-blue-900',
      };
    case 'tron':
      return {
        icon: chainIconMap.tron,
        bgColor: 'bg-red-200',
        textColor: 'text-red-900',
      };
    default:
      return {
        icon: chainIconMap.bitcoin,
        bgColor: 'bg-gray-200',
        textColor: 'text-gray-900',
      };
  }
};

export const BlockchainAvatar = ({
  chain: blockchainType,
}: BlockchainAvatarProps) => {
  const { icon: Icon, bgColor, textColor } = getBlockchainIcon(blockchainType);

  return (
    <Avatar className={`h-16 w-16 flex-shrink-0 ${bgColor}`}>
      <AvatarFallback className={`${bgColor} ${textColor}`}>
        <Icon className="h-8 w-8" />
      </AvatarFallback>
    </Avatar>
  );
};
